import { createI18n } from 'vue-i18n';
import sq from './locales/sq.json';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

export const SUPPORTED_LOCALES = ['sq', 'en', 'de', 'fr'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  sq: 'Shqip',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
};

export const LOCALE_FLAGS: Record<SupportedLocale, string> = {
  sq: '🇦🇱',
  en: '🇬🇧',
  de: '🇩🇪',
  fr: '🇫🇷',
};

export const i18n = createI18n({
  legacy: false,
  locale: 'sq',
  fallbackLocale: 'en',
  messages: {
    sq,
    en,
    de,
    fr,
  },
});

/** Swap the active locale from anywhere. */
export function setI18nLocale(locale: SupportedLocale): void {
  i18n.global.locale.value = locale;
  document.documentElement.setAttribute('lang', locale);
}
